import React, { Component } from 'react'
import { base } from '../../base';
import SideMenu from '../admin/SideMenu';
import { Button } from 'reactstrap';
import '../../styles/css/AdminMain.css'

class SetUpCurrentSession extends Component {
    constructor(props) {
        super(props);

        this.state = {
          sessionList: [],
          currentSession: {},
          loadingScreenOn: false
        };
    }

    componentWillMount() {
      this.sessions = base.syncState(`sessionList`, {
        context: this,
        state: 'sessionList',
        asArray: true
      });
      this.currentSessionRef = base.syncState(`currentSession`, {
        context: this,
        state: 'currentSession',
      });
      this.loadingScreenOnRef = base.syncState(`loadingScreenOn`, {
        context: this,
        state: 'loadingScreenOn'
      });
    }

    componentWillUnmount() {
      base.removeBinding(this.currentSessionRef);
      base.removeBinding(this.sessions);
      base.removeBinding(this.loadingScreenOnRef);
    }

    makeCurrentSession(session){
      base.post('currentSession', {
        data: { sessionName: session.sessionName, questions: session.questions, id: session.id},
        then(err) {
            console.log("Uploaded Successfully");
        }
      })
    }

    toggleLoadingScreen(){
      this.setState({
        loadingScreenOn: !this.state.loadingScreenOn,
      });
    }

    render() {
      var currentSession = this.state.currentSession;
      if(Object.keys(currentSession).length === 0){
        currentSession = null
      }
      var currentSessionTitle = '';
      var currentSessionId = '';
      if(currentSession){
        currentSessionTitle = currentSession.sessionName;
        currentSessionId = currentSession.id;
      }
      var loadingButtonText = "HIDE LOADING SCREEN";
      if(this.state.loadingScreenOn){
        loadingButtonText = "SHOW LOADING SCREEN"
      }
        return (
          <div className="admin-wrapper">
            <SideMenu/>
            <div className="admin-main-panel">
              <h1>Set Current Session</h1>

              <h2 className="lines-on-sides">Current Session</h2>
              <div className="current-session question-box">
                <Button className="btn btn-warning btn-admin btn-current-session" onClick={ () => this.toggleLoadingScreen()}>{loadingButtonText}</Button>
                <h4>{currentSessionTitle}</h4>
                <h4>Id: {currentSessionId}</h4>
                <ol>
                {
                  currentSession ? (
                    currentSession.questions.map(function(item,i){
                      return <li key={i}>{item.question}</li>
                    })
                  ) : (
                    <h4>No Current Session</h4>
                  )
                }
                </ol>
              </div>

              <h2 className="lines-on-sides">Sessions</h2>
              <div className="admin-grid-container">
              {
                this.state.sessionList.map(function(item,i){
                  if(!item.sideSession){
                    return <div key={i} className="question-box">
                        <p><strong>Session Name:</strong> {item.sessionName}</p>
                        <p><strong>Session Id:</strong> {item.id}</p>
                        <ol>
                        {
                          item.questions.map(function(question,t){
                            return <li key={t}>{question.question}</li>
                          })
                        }
                        </ol>
                        <Button className="btn btn-default btn-admin" onClick={ () => this.makeCurrentSession(item)}>Make Current Session <i className="fa fa-plus" aria-hidden="true"></i></Button>
                      </div>
                  }
                }, this)
              }
              </div>
            </div>
         </div>
        );
    }
}

export default SetUpCurrentSession;



// WEBPACK FOOTER //
// ./src/components/admin/SetUpCurrentSession.js